import { gql } from "@apollo/client";

export const listStores = gql`
  query ListStores($filters: KeywordGroupFilter) {
    listKeywordGroups(type: "OUTLET", filters: $filters) {
      id
      type
      slug
      imageUrl
      keywords
      name
      deleted
      metadata
      category
    }
  }
`;
